"use client";

import "./ERPCtaSection.scss";
import ContactForm from "@/components/ContactForm/ContactForm";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const ERPCtaSection = () => {
  return (
    <section className="erp-cta-section">
      <Container>
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="erp-cta-content">
              <h2>From Cost to Go-Live — Book Your ERP Demo Today</h2>
              <p>
                Plan your ERP journey with complete visibility and confidence. Book your demo
                today to gain a clear understanding of costs, timelines, and the value your business
                will achieve. Get a tailored estimate based on your business needs and operational
                goals. Understand the complete implementation roadmap from start to go-live.
                 Make informed decisions with expert guidance and zero hidden surprises.
              </p>
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6} data-aos="zoom-in">
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ERPCtaSection;
